import { catchErrorLogin } from '../../utils/CatchErrorLogin/CatchErrorLogin'

export const AuthOrganization = (organization: string) => {
  try {
    // if (organization === 'linkcom' || organization === 'arnia') {
    if (organization) {
      localStorage.setItem('X-TENANT-ID', JSON.stringify(organization))
      return { logged: true, message: `Organização ${organization}` }
    }
    // }
  } catch (error) {
    return catchErrorLogin(error)
  }

  return {
    logged: false,
    message: 'Algo de errado aconteceu!',
  }
}
